<template>
    <header class="header">
      <div class="header__content">
            <img
                v-if="showMenuButton"
          class="header__mobile-logo"
                :src="logoSrc"
                alt="Porsche Croatia"
            />

        <div class="header__title-group">
          <h1 class="header__title">{{ projectName }}</h1>

                <nav
                    v-if="breadcrumbs.length"
            class="header__breadcrumbs"
                    aria-label="Breadcrumbs"
                >
                    <template
                        v-for="(breadcrumb, index) in breadcrumbs"
                        :key="breadcrumb"
                    >
                        <span>{{ breadcrumb }}</span>
                        <span
                            v-if="index < breadcrumbs.length - 1"
                  class="header__breadcrumb-separator"
                        >></span>
                    </template>
                </nav>
            </div>

        <div
          v-if="!showMenuButton"
          class="header__actions"
        >
          <span class="header__user">{{ displayName }}</span>
                <v-btn
            class="button button--outline header__logout"
                    variant="outlined"
                    rounded="lg"
                    size="large"
                    @click="logout"
                >
                    Odjava
                </v-btn>
            </div>

            <v-btn
                v-if="showMenuButton"
                aria-label="Otvori izbornik"
            class="button button--icon header__menu-button"
                icon="mdi-menu"
                variant="text"
                @click="toggleMenu"
            />
        </div>
    </header>
</template>

<script setup>
import { computed } from 'vue'
import logoSrc from '../assets/images/porsche-croatia-logo.svg'
import { useMsal } from '../auth/useMsal'

const { instance, accounts } = useMsal()

defineProps({

  projectName: {
    type: String,
    default: 'Vento',
  },

  breadcrumbs: {
    type: Array,
    default: () => [],
  },

  showMenuButton: {
    type: Boolean,
    default: false,
  },
})

// Signed-in MSAL account's display name, falling back to its username (UPN/email).
const displayName = computed(() => accounts.value[0]?.name || accounts.value[0]?.username || '')

const emit = defineEmits(['toggle-menu'])

function logout () {
  instance.logoutRedirect()
}

function toggleMenu () {
  emit('toggle-menu')
}
</script>

<style
    scoped
    lang="scss"
>
.header {
    height: auto;
    background: var(--color-white);

    @include breakpoint-up("sm") {
        height: 100px;
        background: rgb(var(--v-theme-background));
    }

    &__content {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: clamp-bp("sm", "xl", 16, 24);
        min-height: 64px;
        padding: 16px 20px 16px 28px;

        @include breakpoint-up("sm") {
            align-items: flex-start;
            min-height: 0;
            padding: 20px clamp-bp("sm", "xl", 20, 32);
        }
    }

    &__menu-button {
        display: inline-flex;
        flex: 0 0 auto;
    }

    &__mobile-logo {
        display: block;
        width: 82px;
        height: auto;

        @include breakpoint-up("sm") {
            display: none;
        }
    }

    &__title-group {
        display: none;
        min-width: 0;

        @include breakpoint-up("sm") {
            display: block;
        }
    }

    &__title {
        margin: 0;
        color: var(--color-black);
        font-size: clamp-bp("sm", "xl", 22, 24);
        font-style: normal;
        font-weight: 600;
        line-height: clamp-bp("sm", "xl", 30, 32);
    }

    &__breadcrumbs {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-top: 2px;
        color: rgb(var(--v-theme-muted, 111, 119, 130));
        font-weight: 300;
        font-size: clamp-bp("sm", "xl", 13, 14);
        line-height: clamp-bp("sm", "xl", 20, 22);
    }

    &__actions {
        display: flex;
        align-items: center;
        align-content: center;
        gap: 12px;
        padding-top: 4px;
    }

    &__user {
        color: var(--color-black);
        font-size: clamp-bp("sm", "xl", 15, 16);
        font-weight: 600;
        line-height: clamp-bp("sm", "xl", 22, 24);
    }

    &__logout {
        width: 82px;
        min-width: 82px;
        height: 36px;
        font-size: clamp-bp("sm", "xl", 15, 16);
        line-height: clamp-bp("sm", "xl", 22, 24);
    }
}
</style>
